// extracted by mini-css-extract-plugin
export default {"feedbackContainer":"V1-z","upvoteIcon":"W1-z","downvoteIcon":"X1-z","feedbackIcon":"Y1-z"};